import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

export const selectGeo = createSelector([(state: RootState) => state.geo], (geo) => geo);
